import { createChuziClient } from "@chuzi/shared/api";
import { auth } from "./auth";

// In development (vite dev) this is '' so requests go to /api/... and the
// Vite proxy forwards them to the real API — no CORS headers needed.
// In production set VITE_CHUZI_API_URL to the full API base URL in your
// build environment and add the SPA domain to the API's FRONTEND_URLS secret.
const baseUrl = import.meta.env.VITE_CHUZI_API_URL ?? "";

/**
 * Singleton CHUZI API client for the SPA. Bearer-token auth from
 * localStorage. All app code talks to the API through this object —
 * never via raw fetch.
 */
export const api = createChuziClient({
  baseUrl,
  client: "chuzi-web",
  getToken: () => auth.getToken(),
});

